import Vue from "vue";
import moment from "moment"

export default {

    async getUserToken() {
        let params = await Vue.prototype.$getItem("simjob_params");
        if (params) return params.accessToken;
        else return null;

    },

    async isTriggers() {
        let userParams = await this.getUserParams();
        //console.log(userParams);
        if (!userParams) return false;
        return userParams.triggers;
    },

    async claimExist(access, claims) {

        let isAdmin = await this.isAdmin();
        if (isAdmin) return true;
        if (!claims) claims = await this.getUserClaims();
        if (Array.isArray(access)) {
            let allow = false;
            access.forEach(a => {
                if (claims.filter(c => c.type == a.type && c.value == a.value).length > 0)
                    allow = true;
            });

            return allow;
        }
        return claims.filter(c => c.type == access.type && c.value == access.value).length > 0
    },

    async isAdmin(claims) {
        if (!claims) claims = await this.getUserClaims();
        return claims.filter(c => c.type == "Admin").length > 0;
    },
    async getUserClaims() {
        let params = await Vue.prototype.$getItem("simjob_params");

        if (params) return params.claims;
        else return []
    },
    async tokenAllowed() {
        let userParams = await this.$auth.getUserParams();
        if (!userParams) return false;
        let expiration = userParams.expiration;
        if (!expiration) return false;
        let expirationDate = moment(expiration).toDate();
        let now = Date.now();
        return expirationDate > now;

    },
    async isAuthenticatedAPI() {
        let token = await this.getUserToken();
        if (!token) return false;
        let res = await Vue.prototype.$http.get("user/IsAuthenticated");
        if (!res.success) return false;
        return res.data;
    },
    async removeUserParams() {
        await Vue.prototype.$removeItem("simjob_params");
    },
    async getUserParams() {
        return await Vue.prototype.$getItem("simjob_params");
    },

    async saveUserParams(params) {
        await Vue.prototype.$setItem("simjob_params", params);
    },

    async login(username, password) {
        let model = { username, password };
        let res = await Vue.prototype.$http.post("token", model);
        if (res.success) {
            await this.saveUserParams(res.data);
        }
        return res;
    },
    async logout() {
        let res = await Vue.prototype.$http.post("user/logout");
        if (res.success) {
            await this.removeUserParams();
        }
        localStorage.clear();
        return res;
    }
}